// Supply · Issuance — the issuance-side work surface. S1 / S2 / S3 sections,
// each with a live chart, must-win category drill-down, vendors with their
// own actions, and a supply-filtered ledger at the bottom.

import { SideDashboard } from "../components/SideDashboard";

export function SupplyPage() {
  return <SideDashboard side="supply" />;
}
